import { observer } from 'mobx-react';
import React from 'react';
import { Button, FormGroup, Input, InputGroup, Label } from 'reactstrap';
import ErrorList from '~/components/ErrorList';
import { NameServerConfiguration } from './NameServerHelper';

type NameServerListEditorProps = {
    config: NameServerConfiguration;
    // A stable prefix for input/label ids, unique per mounted editor (e.g. "manage-nameserver").
    idPrefix: string;
    disabled?: boolean;
};

// Dynamic add/remove nameserver editor. Errors are held on each row object (NameServerItem) and
// re-derived from the server response each submit, so removing a row drops its error rather than
// leaving a stale per-index error pointing at the wrong field.
@observer
export class NameServerListEditor extends React.Component<NameServerListEditorProps> {
    render() {
        const { config, idPrefix, disabled } = this.props;
        return (
            <div>
                {config.items.map((item, idx) => {
                    const inputId = `${idPrefix}-${item.id}`;
                    return (
                        <FormGroup key={item.id}>
                            <Label for={inputId}>Nameserver {idx + 1}</Label>
                            <InputGroup>
                                <Input
                                    id={inputId}
                                    type="text"
                                    value={item.value}
                                    disabled={disabled}
                                    invalid={item.errors.length > 0}
                                    onChange={(e) => item.setValue(e.currentTarget.value)}
                                />
                                <Button
                                    outline
                                    color="danger"
                                    type="button"
                                    disabled={disabled}
                                    aria-label={`Remove nameserver ${idx + 1}`}
                                    title="Remove nameserver"
                                    onClick={() => config.deleteItem(idx)}
                                >
                                    <i className="icon ion-md-trash"></i>
                                </Button>
                            </InputGroup>
                            <ErrorList errors={item.errors} />
                        </FormGroup>
                    );
                })}
                <Button
                    type="button"
                    size="sm"
                    disabled={disabled || !config.canAdd}
                    onClick={() => config.addNewItem()}
                >
                    <i className="icon ion-md-add"></i>&nbsp;Add Nameserver
                </Button>
                <ErrorList errors={config.listErrors} />
            </div>
        );
    }
}
